/**
 * <content-with-video> — sections/content-with-video.liquid
 */
(function () {
  if (customElements.get("content-with-video")) return;

  const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
  const NO_HOVER_QUERY = "(hover: none)";

  class ContentWithVideo extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector(".cwv_media");
      this.video = this.querySelector("video");
      this.toggle = this.querySelector("[data-cwv-video-toggle]");

      this.reducedMotionQuery = window.matchMedia(REDUCED_MOTION_QUERY);
      this.noHoverQuery = window.matchMedia(NO_HOVER_QUERY);

      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);

      this.setupVideo();
      this.setupProducts();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener("pointerdown", this.onDocumentPointerDown);
    }

    setupVideo() {
      if (!this.video) return;

      /* Muted + inline is what lets mobile browsers autoplay at all */
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.setAttribute("muted", "");
      this.video.setAttribute("playsinline", "");
      this.video.setAttribute("webkit-playsinline", "");
      this.video.controls = false;

      if (this.toggle) {
        this.toggle.addEventListener("click", () => this.toggleVideo());
      }

      this.video.addEventListener("play", () => this.syncToggle(true));
      this.video.addEventListener("pause", () => this.syncToggle(false));

      const wantsAutoplay =
        this.dataset.videoMode === "autoplay" && !this.reducedMotionQuery.matches;

      if (!wantsAutoplay || !("IntersectionObserver" in window)) return;

      /* Only play while the video is actually on screen */
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playVideo();
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.4 },
      );

      this.observer.observe(this.media || this);
    }

    playVideo() {
      const attempt = this.video.play();
      if (!attempt || typeof attempt.catch !== "function") return;

      /* Blocked autoplay simply leaves the play button visible */
      attempt.catch(() => this.syncToggle(false));
    }

    toggleVideo() {
      if (this.video.paused) {
        this.playVideo();
      } else {
        this.video.pause();
      }
    }

    syncToggle(isPlaying) {
      if (!this.toggle) return;

      this.toggle.setAttribute("aria-pressed", isPlaying ? "true" : "false");

      const label = isPlaying ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay;
      if (label) this.toggle.setAttribute("aria-label", label);
    }

   
    setupProducts() {
      this.products = Array.from(this.querySelectorAll("[data-cwv-product]"));
      if (!this.products.length) return;

      this.products.forEach((product) => {
        product.addEventListener("click", (event) => {
          if (!this.noHoverQuery.matches) return;
          if (product.classList.contains("is-open")) return;

          event.preventDefault();
          this.closeProducts(product);
          product.classList.add("is-open");
        });
      });

      document.addEventListener("pointerdown", this.onDocumentPointerDown);
    }

    onDocumentPointerDown(event) {
      if (!this.products || !this.products.length) return;
      if (event.target.closest("[data-cwv-product]")) return;

      this.closeProducts();
    }

    closeProducts(except) {
      this.products.forEach((product) => {
        if (product !== except) product.classList.remove("is-open");
      });
    }
  }

  customElements.define("content-with-video", ContentWithVideo);
})();
